function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'loadsh';
export default {
  name: 'TdSearchForm',
  props: {
    formAttr: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    defaultLoadData: {
      type: Boolean,
      default: true
    },
    queryParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dictMap: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    defaultEventKey: {
      type: String,
      default: ''
    },
    showResetBtn: {
      type: Boolean,
      default: true
    },
    searchBtnText: {
      type: String,
      default: '搜索'
    },
    formOptions: {
      type: Array,
      default: [{
        type: '',
        prop: '',
        selectOptionList: [],
        defaultAttr: {
          label: '',
          placeholder: ''
        },
        optionFormat: {
          optionsValue: '',
          optionsLabel: '',
          queryUrl: '',
          resultModel: '',
          allowSearch: true,
          searchParam: {}
        }
      }]
    },
    advOptions: {
      type: Array,
      default: [{
        type: '',
        prop: '',
        selectOptionList: [],
        defaultAttr: {
          label: '',
          placeholder: ''
        },
        optionFormat: {
          optionsValue: '',
          optionsLabel: '',
          queryUrl: '',
          resultModel: '',
          allowSearch: true,
          searchParam: {}
        }
      }]
    }
  },
  data: function data() {
    return {
      optionList: [],
      advOptionList: [],
      isExpand: false
    };
  },
  watch: {
    formOptions: {
      handler: function handler(data) {
        var isAdmin = this.$store.state.user.isAdmin;
        console.log('this.$store.state.user.isAdmin', isAdmin);
        if (isAdmin) {
          this.optionList = _.cloneDeep(data);
        } else {
          var tempList = _.cloneDeep(data);
          this.optionList = tempList.filter(function (x) {
            return !x.hasOwnProperty('needAdmin') || x.hasOwnProperty('needAdmin') && !x['needAdmin'];
          });
        }
        console.log('this.optionList', this.optionList);
        this.selectFormatFn(this.optionList);
        this.selectDictFormatFn(data, this.dictMap);
        this.setDefaultValFn(data, this.dictMap);
      },
      deep: true,
      immediate: true
    },
    advOptions: {
      handler: function handler(data) {
        this.advOptionList = _.cloneDeep(data);
        this.selectFormatFn(this.advOptionList);
        this.selectDictFormatFn(data, this.dictMap);
      },
      deep: true,
      immediate: true
    },
    dictMap: {
      handler: function handler(data) {
        this.selectDictFormatFn(this.optionList, data);
        this.selectDictFormatFn(this.advOptionList, data);
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.defaultLoadData) {
        _this.handleQuery();
      }
    });
  },
  methods: {
    clickTrigger: function clickTrigger(item, list, flag) {
      // if (item.linkedRules) {
      //   item.linkedRules.forEach((childNode) => {
      //     this.changeFn(item, this.queryParams, list, childNode, flag)
      //   })
      // }
    },
    dateDeal: function dateDeal(time, item) {
      var _this2 = this;
      if (!time) {
        this.$nextTick(function () {
          console.log('typeof(item.prop)', _typeof(item.prop));
          if (_typeof(item.prop) == Array) {
            _this2.$set(_this2.queryParams, item.prop, []);
          } else {
            _this2.$set(_this2.queryParams, item.prop, '');
          }
        });
      }
    },
    changeFn: function changeFn(item, form, formListOptions, childNode, flag) {
      if (childNode.ruleType === 'callbackFn') {
        childNode.callback(item, form, formListOptions);
      } else if (childNode.ruleType === 'changeCallback') {
        childNode.callback(this, this.$parent, item, form, formListOptions);
      }
    },
    dealStr: function dealStr(val) {
      return val;
    },
    getSearchParams: function getSearchParams() {
      return this.queryParams;
    },
    handleQuery: function handleQuery() {
      var _this3 = this;
      this.$refs['queryFormRef'].validate(function (valid) {
        if (valid) {
          var outPutTemp = _.cloneDeep(_this3.queryParams);
          _this3.$EventBus.$emit("".concat(_this3.$route.path).concat(_this3.defaultEventKey), outPutTemp);
        }
      });
    },
    resetQuery: function resetQuery() {
      var _this4 = this;
      this.resetForm('queryFormRef');
      this.$emit('resetCallback');
      this.$nextTick(function () {
        _this4.handleQuery();
      });
    },
    selectDictFormatFn: function selectDictFormatFn(list, data) {},
    setDefaultValFn: function setDefaultValFn(list) {
      if (list && list.length) {
        list.forEach(function (item) {});
      }
    },
    selectFormatFn: function selectFormatFn(list) {
      var _this5 = this;
      if (list && list.length) {
        list.forEach(function (item) {
          if (item.type === 'select') {
            var optionsLabel = 'label';
            var optionsValue = 'value';
            if (item.optionFormat && item.optionFormat.optionsLabel) {
              optionsLabel = item.optionFormat.optionsLabel;
            }
            if (item.optionFormat && item.optionFormat.optionsValue) {
              optionsValue = item.optionFormat.optionsValue;
            }
            item.selectOptionList = _this5.selectOptionListFn(item.selectOptionList, optionsLabel, optionsValue);
          }
        });
      }
    },
    selectOptionListFn: function selectOptionListFn(list, optionsLabel, optionsValue) {
      var array = [];
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          array.push({
            label: key[optionsLabel],
            value: key[optionsValue]
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return array;
    },
    toggleMoreCondition: function toggleMoreCondition() {
      this.isExpand = !this.isExpand;
    }
  }
};